/**
 * @auth 赖传峰
 * @date 2022/9/25
 */
import {
  appendGlobalExtData,
  defineNuxtRouteMiddleware,
  useCookie,
} from '#imports'
import { StorageKey } from '~/types/enum'
/* 归因字段逻辑 */
// 记录最近10条来源网站
type StorageReferer = {
  val: string
  expired: number
}
export const storageReferer = {
  _get(): StorageReferer[] {
    const oldReferer: (Record<string, unknown> | StorageReferer)[] = (() => {
      try {
        const val = localStorage.getItem(StorageKey.REFERER_LIST)

        if (!val) return []

        const parsedVal = JSON.parse(val)

        if (Array.isArray(parsedVal)) return parsedVal

        return []
      } catch (e) {
        console.error(e)
        return []
      }
    })()

    return oldReferer
      .filter((el): el is StorageReferer => typeof el.val === 'string' && typeof el.expired === 'number')
      .filter(el => el.expired > Date.now())
      .slice(0, 10) // 最多存储10条记录
  },
  set(): void {
    // NOTICE 请注意，是 document.referrer，不是 document.referer
    const { referrer: referer, location: { host } } = document
    if (!referer) return

    const refererHost = new URL(referer).host

    if (refererHost === host) return

    const oldReferer = this._get()

    // 对比最新的 ref
    const latestRefer = oldReferer[0]
    if (latestRefer?.val === refererHost) return

    oldReferer.unshift({ val: refererHost, expired: Date.now() + 12 * 3600 * 1000 })

    localStorage.setItem(StorageKey.REFERER_LIST, JSON.stringify(oldReferer))
  },
  get(): string[] {
    return this._get().map(el => el.val)
  },
}
export const cookieAttribution = {
  /* 将归因字段保存于 cookie ，有效期12小时 */
  set(query: Partial<Record<string, unknown>>) {
    const {
      __source: source,
      __medium: medium,
      __campaign: campaign,
    } = query
    Object.entries({
      source,
      medium,
      campaign,
    }).forEach(([key, value]) => {
      value && (useCookie(key, { maxAge: 12 * 60 * 60 }).value = value as string) // 有值覆盖，12小时有效
    })
  },
  /* 获取归因字段 */
  get() {
    return Object.fromEntries(['source', 'medium', 'campaign'].map((el) => ([
      [el],
      useCookie(el).value,
    ]))) as Partial<Record<'source' | 'medium' | 'campaign', string>>
  },
}
export default defineNuxtRouteMiddleware(async to => {
  cookieAttribution.set(to.query)

  if (import.meta.server) return

  storageReferer.set()
  appendGlobalExtData(cookieAttribution.get())
})
